// External Dependencies:
import React from 'react'

// Internal Dependencies:
import Image from 'components/Image/Image'

class Advertisement extends React.Component {
	render() {
		const { url, image } = this.props

		return (
			<div className="advertisement-wrap">
				{/*<h4>Advertisement</h4>*/}

				<a className="advertisement" href={ url } target="_blank" rel="noopener noreferrer">
					<Image
						thumb={ image.thumb }
						url={ image.url }
						srcset={ image.srcset }
						sizes={ `(max-width: ${siteData.mobile_max_width}) 100vw, 1100px` }
						alt={ image.alt }
						aspectRatio={ image.aspect_ratio }
					/>
				</a>
			</div>
		)
	}
}

export default Advertisement
